// 营销邮件管理 (FBMPLAY-1231) i18n — 6 个命名空间合并
export default {
  emailSenders: {
    tab: { senders: '发件人' },
    title: '发件人管理',
  
    // 查询表单
    form: {
      channelEmpty: '暂无已配置的发信域名，请先到「发信域名 / 渠道」添加',
      bussType: '业务类型',
      bussTypePlaceholder: '请选择业务类型',
      channel: '渠道',
      channelPlaceholder: '请选择渠道',
      fromEmail: '发件人邮箱',
      fromEmailPlaceholder: '请输入发件人邮箱',
      fromEmailPrefixPlaceholder: '请输入 @ 前的前缀',
      domainPending: '请先选发信域名',
      fromName: 'From Name',
      fromNamePlaceholder: '请输入 From Name',
      status: '状态',
      statusPlaceholder: '请选择状态'
    },
  
    // 表格列
    table: {
      index: '序号',
      fromName: 'From Name',
      bussType: '业务类型',
      fromEmail: 'From Email',
      channel: '渠道',
      lastOperator: '最后操作人·时间',
      status: '状态',
      actions: '操作'
    },
  
    // 业务类型
    bussType: {
      marketing: '营销',
      notification: '通知'
    },
  
    // 渠道
    channel: {
      notConfigured: '未配置域名',
      mailgunApi: 'Mailgun API'
    },
  
    // 状态
    status: {
      enabled: '启用',
      disabled: '禁用'
    },
  
    // 按钮
    button: {
      search: '搜索',
      reset: '重置',
      create: '新增',
      edit: '编辑',
      delete: '删除'
    },
  
    // 弹窗
    modal: {
      createTitle: '新增发件人',
      editTitle: '编辑发件人'
    },
  
    // 校验
    validation: {
      domainMismatch: 'From Email 的域名（{{emailDomain}}）与所选发信域名（{{channelDomain}}）不一致',
      domainNotConfigured: '域名 {{domain}} 尚未配置渠道 / Key，请先到「发信域名 / 渠道」添加',
      bussTypeRequired: '请选择业务类型',
      channelRequired: '请选择渠道',
      fromEmailRequired: '请输入发件人邮箱',
      fromEmailInvalid: '请输入有效的邮箱地址',
      fromEmailPrefixRequired: '请输入发件人邮箱前缀',
      fromEmailPrefixInvalid: '前缀只能包含字母、数字及 . _ - + 等常见符号',
      fromNameRequired: '请输入 From Name',
      statusRequired: '请选择状态'
    },
  
    // 确认
    confirm: {
      enable: '确定要启用此发件人吗？',
      disable: '确定要禁用此发件人吗？',
      delete: '确定要删除此发件人吗？',
      okText: '确定',
      cancelText: '取消'
    },
  
    // 消息
    message: {
      queryFailed: '查询失败',
      createSuccess: '创建成功',
      createFailed: '创建失败',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      statusUpdateSuccess: '状态更新成功',
      statusUpdateFailed: '状态更新失败'
    }
  },
  emailTemplates: {
    title: '邮件模板',
  
    loadingMore: '加载中...',
    copySuffix: '-副本',
  
    // 表单相关
    form: {
      tempName: '模板名称',
      tempNamePlaceholder: '请输入模板名称',
      country: '地区',
      countryPlaceholder: '请选择地区',
      category: '模板分类',
      categoryPlaceholder: '请选择分类',
      bussType: '业务类型',
      bussTypePlaceholder: '请选择业务类型',
      fromEmail: '发件人',
      fromEmailPlaceholder: '请选择发件人',
      tempTitle: '邮件标题',
      tempTitlePlaceholder: '请输入邮件标题（Subject）',
      status: '状态',
      statusPlaceholder: '请选择状态',
      content: '邮件正文',
      contentPlaceholder: '请输入邮件正文（支持 HTML），可插入变量：{{memberAccount}}'
    },
  
    // 业务类型
    bussType: {
      marketing: '营销',
      notification: '通知'
    },
  
    // 表格相关
    table: {
      tempId: '模板ID',
      tempName: '模板名称',
      bussType: '类型',
      country: '地区',
      category: '分类',
      tempTitle: '邮件标题',
      lastOperate: '最后操作人·时间',
      status: '状态',
      actions: '操作'
    },
  
    // 状态相关
    status: {
      enabled: '启用',
      disabled: '禁用'
    },
  
    // 按钮相关
    button: {
      create: '新建模板',
      copy: '复制',
      test: '测试发送'
    },
  
    // 弹窗相关
    modal: {
      createTitle: '新建邮件模板',
      editTitle: '编辑邮件模板'
    },
  
    // 模板变量相关
    variables: {
      example: '示例',
      group: { COMMON: '通用', TRANSACTION: '交易类', ACTIVITY: '活动类' },
      title: '支持的模板变量',
      tip: '点击变量可插入到邮件正文中',
      memberAccount: '会员账号'
    },
  
    // 验证相关
    validation: {
      tempNameRequired: '请输入模板名称',
      countryRequired: '请选择地区',
      categoryRequired: '请选择模板分类',
      bussTypeRequired: '请选择业务类型',
      fromEmailRequired: '请选择发件人',
      tempTitleRequired: '请输入邮件标题',
      contentRequired: '请输入邮件正文',
      statusRequired: '请选择状态'
    },
  
    // 消息相关
    message: {
      queryFailed: '查询失败',
      createSuccess: '创建成功',
      createFailed: '创建失败',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      copySuccess: '复制成功',
      copyFailed: '复制失败',
      statusUpdateSuccess: '状态更新成功',
      statusUpdateFailed: '状态更新失败'
    },
  
    // 确认相关
    confirm: {
      delete: '确定要删除此模板吗？',
      toggleStatus: '确定要切换此模板的状态吗？'
    },
  
    // 分页相关
    pagination: {
      total: '共 {{total}} 条记录'
    },
  
    // 测试发送相关
    test: {
      title: '测试发送邮件',
      templateName: '模板名称',
      templateTitle: '邮件标题',
      templateContent: '邮件正文',
      inputLabel: '收件人',
      inputPlaceholder: '请输入邮箱地址或会员账号',
      inputHint: '系统会自动识别您输入的是邮箱地址还是会员账号',
      send: '发送',
      inputRequired: '请输入邮箱地址或会员账号',
      success: '测试发送成功',
      failed: '测试发送失败',
      error: '测试发送出错',
      userNotFound: '测试用户不在系统内'
    },
  
    // 分类管理相关
    category: {
      modal: {
        title: '模板分类管理'
      },
      table: {
        id: 'ID',
        name: '分类名称',
        actions: '操作'
      },
      form: {
        namePlaceholder: '请输入分类名称'
      },
      button: {
        create: '新建分类'
      },
      confirm: {
        delete: '确定要删除此分类吗？',
        deleteDesc: '删除后无法恢复，请谨慎操作'
      },
      allCategories: '全部分类',
      nameRequired: '请输入分类名称',
      nameExists: '分类名称已存在',
      queryFailed: '查询分类失败',
      createSuccess: '创建分类成功',
      createFailed: '创建分类失败',
      deleteSuccess: '删除分类成功',
      deleteFailed: '删除分类失败'
    }
  },
  emailTasks: {
    title: '邮件群发',
  
    button: {
      createInternalCampaign: '新增站内用户群发',
      createExternalCampaign: '新增站外用户群发',
      view: '查看',
      edit: '编辑',
      delete: '删除',
      sendNow: '立即发送',
      uploadFile: '上传文件',
      importLog: '导入名单日志',
      reset: '重置'
    },
  
    form: {
      taskName: '任务名称',
      taskNamePlaceholder: '请输入任务名称',
      operator: '操作人',
      operatorPlaceholder: '请输入操作人',
      region: '地区',
      regionPlaceholder: '请选择地区',
      status: '状态',
      statusPlaceholder: '请选择状态',
      sendTime: '发送时间',
      mode: '模式',
      modeFilter: '群发（按条件筛选）',
      modeImport: '导入用户名（上传CSV）',
      category: '分类',
      categoryPlaceholder: '请选择分类',
      template: '邮件模板',
      templatePlaceholder: '请选择邮件模板',
      agent: '代理名称',
      agentPlaceholder: '请选择代理名称',
      fromEmail: '发件人',
      fromEmailPlaceholder: '选择模板后自动带出',
      templateContent: '模板内容',
      templateContentPlaceholder: '选择模板后自动带出内容',
      trackStatus: '开启打开/点击追踪',
      uploadEmailList: '上传邮箱名单',
      chooseFile: '选择文件',
      uploaded: '已上传'
    },
  
    table: {
      taskName: '任务名称',
      template: '模板',
      region: '地区',
      operator: '操作人',
      createTime: '创建时间',
      sendTime: '发送时间',
      actions: '操作'
    },
  
    status: {
      pendingUpload: '待上传名单',
      pendingSend: '待发送',
      ready: '名单就绪',
      completed: '已完成',
      sent: '已发送'
    },
  
    confirm: {
      delete: '确定要删除该任务吗？',
      send: '确定要立即发送吗？'
    },
  
    validation: {
      taskNameRequired: '请输入任务名称',
      regionRequired: '请选择地区',
      categoryRequired: '请选择分类',
      templateRequired: '请选择邮件模板',
      agentRequired: '请选择代理名称'
    },
  
    message: {
      queryFailed: '查询失败',
      createSuccess: '创建成功',
      createFailed: '创建失败',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      sendSuccess: '发送成功',
      sendFailed: '发送失败'
    },
  
    upload: {
      success: '上传成功',
      failed: '上传失败',
      error: '上传出错：{error}',
      invalidFileType: '文件格式不支持，请上传 Excel 或 CSV 文件',
      pleaseUploadFirst: '请先上传名单文件'
    },
  
    modal: {
      createTitle: '新增邮件群发',
      editTitle: '编辑邮件群发',
      viewTitle: '查看邮件群发',
      importLogTitle: '导入名单日志',
      close: '关闭'
    },
  
    importLog: {
      result: { excluded: '已剔除', failed: '失败', excludedReason: '已退订，不再发送' },
      loading: '加载中...',
      header: {
        taskName: '任务名称',
        operator: '操作人',
        importFileName: '导入文件名',
        importCompleteTime: '导入完成时间',
        importStatus: '导入状态'
      },
      stats: {
        excluded: '因退订剔除',
        success: '成功导入',
        failed: '导入失败',
        total: '导入总数'
      },
      failureDetails: {
        result: '结果',
        title: '失败明细',
        target: '收件目标',
        failureReason: '失败原因',
        noFailedRecords: '无失败记录',
        noImportRecords: '暂无导入记录'
      },
      uploadFileStatus: {
        '0': '处理中',
        '1': '已完成',
        '2': '失败'
      }
    },
  
    pagination: {
      total: '共 {total} 条'
    }
  },
  emailLogs: {
    title: '发送日志',
  
    // 表单相关
    form: {
      sendTime: '发送时间',
      sendTimePlaceholder: '请选择发送时间',
      startDate: '开始日期',
      endDate: '结束日期',
      region: '地区',
      regionPlaceholder: '请选择地区',
      task: '任务名称',
      taskPlaceholder: '请输入任务名称',
      subTypePlaceholder: '请选择子类型/会员类型',
      subTypeMemberGroup: '会员类型',
      taskType: '发送类型',
      taskTypePlaceholder: '请选择发送类型',
      bussType: '业务类型',
      bussTypePlaceholder: '请选择业务类型',
      account: '会员账号 / 邮箱',
      accountPlaceholder: '请输入会员账号或邮箱',
      status: '状态',
      statusPlaceholder: '请选择状态'
    },
  
    // 表格相关
    table: {
      time: '发送时间',
      task: '任务名称',
      region: '地区',
      type: '类型',
      user: '会员账号',
      email: '邮箱',
      status: '状态',
      openTime: '打开',
      remark: '失败原因'
    },
  
    // 业务类型
    type: {
      bulk: '群发',
      ndc: '新客',
      inactive: '沉睡',
      churn: '流失',
      vip: 'VIP',
      welcome: '欢迎',
      restorage: '复存'
    },
  
    // 状态相关
    status: {
      submitted: '已提交',
      accepted: '已提交',
      delivered: '已送达',
      opened: '已打开',
      failed: '失败',
      unsubscribed: '已退订',
      complained: '投诉',
      unknown: '未知'
    },
  
    // 导出相关
    export: {
      button: '导出',
      loading: '导出任务已创建，请在下载列表中查看进度',
      noData: '无数据可导出',
      tooMany: '单次最多导出 10 万条，请缩小筛选范围'
    },
  
    // 消息相关
    message: {
      queryFailed: '查询失败',
      exportSuccess: '导出成功',
      exportFailed: '导出失败'
    },
  
    // 分页相关
    pagination: {
      total: '共 {{total}} 条记录'
    }
  },
  emailReport: {
    // 页面标题
    title: '发送报表',
    subtitle: '邮件发送统计和分析报表',
  
    // 表单字段
    form: {
      startTime: '开始时间',
      startTimeRequired: '请选择开始时间',
      startTimePlaceholder: '请选择开始时间',
      endTime: '结束时间',
      endTimeRequired: '请选择结束时间',
      endTimePlaceholder: '请选择结束时间',
      taskName: '任务名称',
      taskNamePlaceholder: '请输入任务名称',
      channel: '渠道',
      channelPlaceholder: '请选择渠道',
      status: '状态',
      statusPlaceholder: '请选择状态',
      region: '地区',
      regionPlaceholder: '请选择地区'
    },
  
    // 任务状态
    status: {
      pending: '待发送',
      sending: '发送中',
      completed: '已完成'
    },
  
    // 渠道
    channel: {
      mailgunApi: 'Mailgun API'
    },
  
    // 地区
    region: {
      ph: 'PH - 菲律宾',
      vn: 'VN - 越南',
      th: 'TH - 泰国',
      cn: 'CN - 中国'
    },
  
    // 按钮
    button: {
      search: '查询',
      reset: '重置',
      export: '导出'
    },
  
    // 表格列头
    table: {
      date: '日期',
      task: '任务名称',
      targetCount: '目标数',
      sendCount: '提交数',
      deliveredCount: '成功数',
      failedCount: '失败数',
      openedCount: '打开数',
      actions: '操作',
      viewLogs: '查看日志'
    },
  
    // 日志弹窗
    logs: {
      title: '发送日志',
      time: '时间',
      task: '任务',
      user: '用户',
      email: '邮箱',
      channel: '渠道',
      status: '状态',
      remark: '备注',
      statusPending: '待发送',
      statusSuccess: '成功',
      statusFailed: '失败',
      statusUnknown: '未知'
    },
  
    // 消息提示
    message: {
      selectTimeRange: '请选择开始与结束时间',
      exportSuccess: '导出成功',
      exportFailed: '导出失败',
      exporting: '正在导出数据...',
      queryFailed: '查询失败',
      noData: '暂无数据'
    },
  
    // 分页
    pagination: {
      total: '共 {total} 条记录'
    }
  },
  emailUnsubscribe: {
    title: '退订列表',
  
    // 表单 / 筛选相关
    form: {
      unsubscribeTime: '退订时间',
      startDate: '开始日期',
      endDate: '结束日期',
      emailAddress: '邮箱地址',
      emailAddressPlaceholder: '请输入邮箱地址',
      memberAccount: '会员账号',
      memberAccountPlaceholder: '请输入会员账号',
      originType: '退订来源',
      originTypePlaceholder: '请选择退订来源',
      reason: '原因',
      reasonPlaceholder: '请选择原因',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      search: '查询',
      reset: '重置'
    },
  
    // 表格相关
    table: {
      nonMember: '非会员',
      unsubscribeTime: '退订时间',
      emailAddress: '邮箱地址',
      memberAccount: '会员账号',
      originType: '来源',
      remark: '备注',
      actions: '操作'
    },
  
    // 退订来源
    originType: {
      all: '全部',
      selfUnsubscribe: '自助退订(退订链接)',
      complaint: '投诉/主动要求',
      manual: '客服手动新增'
    },
  
    // 新增退订弹窗
    add: {
      mode: '退订方式',
      modeMember: '按会员账号',
      modeEmail: '按邮箱',
      modeEmailHint: '用于非会员 / 投诉等兜底场景',
      lookupEmail: '查询邮箱',
      validEmail: '已认证邮箱（自动带出，脱敏，只读）',
      validEmailPlaceholder: '查询会员账号后自动带出',
      button: '新增退订',
      title: '新增退订',
      okText: '确定',
      cancelText: '取消'
    },
  
    // 删除相关
    delete: {
      button: '删除',
      confirm: '确定要删除该退订记录吗？',
      okText: '确定',
      cancelText: '取消',
      complaintBlocked: '投诉/主动要求的退订记录不可删除，仅「客服手动新增」的记录可以删除。'
    },
  
    // 验证相关
    validation: {
      memberAccountRequired: '请输入会员账号',
      lookupFirst: '请先点「查询邮箱」确认该会员的已认证邮箱',
      emailAddressRequired: '请输入邮箱地址',
      emailAddressInvalid: '请输入正确的邮箱地址',
      reasonRequired: '请选择原因'
    },
  
    // 消息相关
    message: {
      lookupFailed: '查询会员邮箱失败',
      queryFailed: '查询失败',
      addSuccess: '新增成功',
      addFailed: '新增失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  },
  emailAutoPushConfig: {
    title: '自动邮件配置',

    searchForm: {
      language: '语言',
      languagePlaceholder: '请选择语言',
      bussType: '业务类型',
      bussTypePlaceholder: '请选择业务类型',
      aimType: '目标类型',
      aimTypePlaceholder: '请选择目标类型',
      subPushType: '子类型',
      subPushTypePlaceholder: '请选择子类型',
      memberType: '会员类型',
      memberTypePlaceholder: '请选择会员类型',
      status: '状态',
      statusPlaceholder: '请选择状态',
      search: '查询',
      reset: '重置',
      add: '新增规则'
    },

    table: {
      language: '语言',
      aimType: '目标类型',
      subTypeOrMember: '子类型/会员类型',
      ruleName: '规则名称',
      template: '模板',
      status: '状态',
      operation: '操作',
      edit: '编辑'
    },

    aimType: {
      scene: '场景触发',
      target: '目标用户'
    },

    pushSwitch: {
      enabled: '启用',
      disabled: '禁用'
    },

    confirm: {
      enable: '确定要启用此规则吗？',
      disable: '确定要禁用此规则吗？',
      okText: '确定',
      cancelText: '取消'
    },

    modal: {
      addTitle: '新增自动邮件规则',
      editTitle: '编辑自动邮件规则',
      baseInfoTitle: '基础信息',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      language: '语言',
      languagePlaceholder: '请选择语言',
      aimType: '目标类型',
      pushType: '触发事件',
      pushTypePlaceholder: '请选择触发事件',
      subPushType: '子类型',
      subPushTypePlaceholder: '请选择子类型',
      loginChannel: '登录终端',
      loginChannelPlaceholder: '请选择登录终端',
      memberType: '会员类型',
      memberTypePlaceholder: '请选择会员类型',
      sendTime: '发送时机',
      sendTimePlaceholder: '请输入发送时机',
      sendTimePlaceholderDay: '请输入天数',
      sendTimePlaceholderWeek: '请输入1-7（1=周一，7=周日）',
      sendTimePlaceholderMonth: '请输入1-31（每月几号）',
      sendTimeUnit: '时间单位',
      status: '状态',
      enable: '启用',
      disable: '禁用',
      emailContentTitle: '邮件内容',
      bussType: '业务类型',
      bussTypePlaceholder: '请选择业务类型',
      tempClassify: '模板分类',
      tempClassifyPlaceholder: '请选择模板分类',
      template: '选择模板',
      templatePlaceholder: '请选择模板',
      preview: {
        fromEmail: '发件人',
        tempTitle: '邮件标题',
        tempContent: '邮件内容'
      }
    },

    validation: {
      ruleNameRequired: '请输入规则名称',
      languageRequired: '请选择语言',
      subPushTypeRequired: '请选择子类型',
      sendTimeRequired: '请输入发送时机',
      sendTimeUnitRequired: '请选择时间单位',
      sendTimeRange: '发送时机取值范围为 {{min}}-{{max}}',
      tempClassifyRequired: '请选择模板分类',
      templateRequired: '请选择模板',
      depositNumberRequired: '请输入存款次序'
    },

    messages: {
      fetchDataFailed: '获取数据失败',
      addSuccess: '新增成功',
      addFailed: '新增失败',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      statusUpdateSuccess: '状态更新成功',
      statusUpdateFailed: '状态更新失败'
    }
  },
  // 发信域名 / 渠道（FBMPLAY-1595 多域名多 Key，发件人管理页 Admin-only Tab）
  emailChannels: {
    title: '发信域名 / 渠道',

    tab: {
      channels: '发信域名',
    },

    hint: {
      perDomainKey: '按域名各配一把 Sending API Key（支持多把）；发件人归属域名、共用其 key。'
    },

    table: {
      sendDomain: '发信域名',
      region: 'Region',
      apiKey: 'Sending API Key',
      apiKeyMissing: '未配置',
      status: '状态',
      lastOperator: '最后操作人·时间',
      actions: '操作'
    },

    form: {
      sendDomain: '发信域名',
      sendDomainPlaceholder: '如 mail.newbrand.com',
      region: 'Region',
      apiKey: 'Sending API Key',
      apiKeyPlaceholder: '粘贴该域名的 Mailgun sending API key',
      apiKeyHint: '只写不回显，保存后仅显示后 4 位打码',
      apiKeyEditHint: '留空 = 保留当前 key（key-••••••••{{tail}}）；填写 = 覆盖换 key',
      status: '状态'
    },

    status: {
      enabled: '启用',
      disabled: '禁用'
    },

    button: {
      create: '新增域名',
      edit: '编辑',
      delete: '删除',
      replaceKey: '换 Key',
      testConnection: '测试连接',
      testing: '测试中…',
      save: '保存',
      cancel: '取消'
    },

    modal: {
      createTitle: '新增发信域名',
      editTitle: '编辑发信域名',
      replaceKeyTitle: '换 Sending API Key'
    },

    validation: {
      sendDomainRequired: '请输入发信域名',
      sendDomainInvalid: '请输入正确的域名，如 mail.newbrand.com',
      regionRequired: '请选择 Region',
      apiKeyRequired: '请输入 Sending API Key'
    },

    confirm: {
      delete: '确定要删除该发信域名吗？',
      enable: '确定要启用该发信域名吗？',
      disable: '确定要禁用该发信域名吗？禁用后该域名下的发件人将无法发送。',
      okText: '确定',
      cancelText: '取消'
    },

    message: {
      queryFailed: '查询失败',
      createSuccess: '新增成功',
      createFailed: '新增失败',
      updateSuccess: '修改成功',
      updateFailed: '修改失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      statusUpdateSuccess: '状态修改成功',
      statusUpdateFailed: '状态修改失败',
      testSuccess: '连接成功（后端用该 key 校验，key 不回传前端）',
      testFailed: '连接失败，请检查域名、Region 与 API Key'
    }
  },
};
